<div class="container">
    <mat-card>
        <h2 mat-title *ngIf="transactionType === 'V' ">Vender USD al cliente</h2>
        <h2 mat-title *ngIf="transactionType === 'C' ">Comprar USD del cliente</h2>
        <form [formGroup]="forexTransactionsForm" (ngSubmit)="submit()">
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <mat-label>Id de cliente</mat-label>
                    <input type="number" formControlName="clientId" required matInput/>
                    <mat-error *ngIf="forexTransactionsForm.controls.clientId.hasError('required')">
                        Id de cliente es <strong>obligatorio</strong>
                    </mat-error>
                </mat-form-field>                                           
                <mat-form-field>
                    <mat-label>Tasa</mat-label>
                    <input type="number" formControlName="rate" required matInput readonly/>
                    <mat-error *ngIf="forexTransactionsForm.controls.rate.hasError('required')">
                        Tasa es <strong>obligatoria</strong>
                    </mat-error>
                </mat-form-field>                
                <mat-form-field>
                    <mat-label>Monto {{transactionType == 'C'? 'en USD' : 'en GTQ' }}</mat-label>
                    <input type="number" formControlName="amount" required matInput/>
                    <mat-error *ngIf="forexTransactionsForm.controls.amount.hasError('required')">
                        Monto es <strong>obligatorio</strong>
                    </mat-error>
                </mat-form-field>                                
                <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
                    <button type="button" mat-raised-button [routerLink]="['/home']">Cancelar</button>
                    <button mat-raised-button color="primary" [disabled]="!forexTransactionsForm.valid">Cambiar</button>
                </mat-card-actions>                
            </mat-card-content>
        </form>
    </mat-card>
</div>